import React from "react";
import ReactDOM from "react-dom";
import { Message } from "../common/message";

const CustomPrompt = (message, callback) => {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const closeModal = (callbackState) => {
    ReactDOM.render(<div></div>, container);
    callback(callbackState);
  };
  ReactDOM.render(
    <Message
      show={true}
      title={"Upozorenje"}
      content={message}
      onNo={() => closeModal(false)}
      onYes={() => closeModal(true)}
      yesLabel={"Da"}
      noLabel={"Ne"}
      hideYes={false}
      hideNo={false}
      hideX={true}
      isWait={false}
    />,
    container
  );
};
export default CustomPrompt;
